"use client";
import { Button } from "@/components/ui/button";
import { buttonVariants } from "@/components/ui/button";
import { HeroCards } from "./HeroCards";
import { GitHubLogoIcon } from "@radix-ui/react-icons";
import Link from "next/link";
import { useTranslation } from "@/hooks/useLanguage";

export const Hero = () => {
  const { t } = useTranslation();
  return (
    <section className="container grid lg:grid-cols-2 place-items-center py-20 md:py-32 gap-10">
      <div className="text-center lg:text-start space-y-6">
        <main className="text-5xl md:text-6xl font-bold leading-tight">
          <h1 className="inline">
            <span className="inline">{t("home.hero.title_1")} </span>
            {t("home.hero.title_1_span")}{" "}
          </h1>
          <h2 className="inline">
            <span className="inline bg-linear-to-r from-[#10B981] via-[#34D399] to-[#059669] text-transparent bg-clip-text">
              {t("home.hero.title_2")}
            </span>
          </h2>
        </main>

        <p className="text-xl text-muted-foreground md:w-10/12 mx-auto lg:mx-0">
          {t("home.hero.description")}
        </p>

        <div className="space-y-4 md:space-y-0 md:space-x-4">
          <Button asChild className="w-full md:w-1/3">
            <Link href="/register">{t("home.hero.book_demo")}</Link>
          </Button>

          <Link
            rel="noreferrer noopener"
            href="#features"
            className={`w-full md:w-1/3 ${buttonVariants({
              variant: "outline",
            })}`}
          >
            {t("common.explore_features")}
          </Link>
        </div>
      </div>

      {/* Hero cards sections */}
      <div className="z-10">
        <HeroCards />
      </div>

      {/* Shadow effect */}
      <div className="shadow"></div>
    </section>
  );
};
